import { render } from "./proyectList.vue?vue&type=template&id=b776b47c&scoped=true"
import script from "./proyectList.vue?vue&type=script&lang=js"
export * from "./proyectList.vue?vue&type=script&lang=js"

import "./proyectList.vue?vue&type=style&index=0&id=b776b47c&scoped=true&lang=css"

import exportComponent from "/home/accesa/Documents/ACCESA/DANA_PROJECTS/DANA-LITE/dana-lite-registro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b776b47c"]])

export default __exports__